export const asFile = {
  data: `<svg width="12" height="14" viewBox="0 0 12 14" xmlns="http://www.w3.org/2000/svg">
  <path d="M7.33366 0.333984H2.00033C1.26699 0.333984 0.673659 0.933984 0.673659 1.66732L0.666992 12.334C0.666992 13.0673 1.26033 13.6673 1.99366 13.6673H10.0003C10.7337 13.6673 11.3337 13.0673 11.3337 12.334V4.33398L7.33366 0.333984ZM2.00033 12.334V1.66732H6.66699V5.00065H10.0003V12.334H2.00033Z" />
  </svg>`,
  name: 'file',
};
